import { BaseModel } from '../base-model';
import { Dominio } from './Dominio';
import { PessoaFisica } from './pessoa-fisica';

export class NotificacaoSistema extends BaseModel {
  constructor(
    public id: number,
    public dtNotificacao: Date,
    public titulo: string,
    public observacao: string,
    public tipo: string,
    public flgVisto: boolean,
    public modulo: string,
    public setor: string,
    public local: string,
    public qtdNotificacao: number,

    public pessoaFisicaId: number,
    public pessoaFisica: PessoaFisica,
  ) { super(); }
}

